import React, {useEffect} from 'react'
import {Row, Col, Button, Card} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import './DemoPageLeadzApp.scss'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const linkCalendly = 'https://calendly.com/nelson-p-cellcast/30min'
declare global {
  interface Window {
    Calendly: {
      initPopupWidget: (options: {url: string}) => void
    }
  }
}

const DemoPageLeadzApp = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const CALENDLY_SCRIPT_SRC =
      "https://assets.calendly.com/assets/external/widget.js";

    function loadCalendlyScript() {
      if (!document.querySelector(`script[src="${CALENDLY_SCRIPT_SRC}"]`)) {
        const script = document.createElement("script");
        script.src = CALENDLY_SCRIPT_SRC;
        script.async = true;
        document.body.appendChild(script);
      }
    }

    function overwriteClosedButton() {
      const btn = document.querySelector(
        ".calendly-overlay .calendly-popup-close"
      ) as HTMLElement | null;

      if (!btn) return;

      if (!btn.dataset.customized) {
        btn.style.setProperty(
          "background",
          `url(${toAbsoluteUrl("/media/svg/closed.svg")}) no-repeat center`,
          "important"
        );
        btn.style.setProperty("background-size", "contain", "important");
        btn.style.setProperty("width", "44px", "important");
        btn.style.setProperty("height", "44px", "important");
        btn.innerHTML = "";
        btn.dataset.customized = "true";
      }
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of Array.from(mutation?.addedNodes)) {
          if (!(node instanceof HTMLElement)) {
            continue;
          }

          if (
            node.classList.contains("calendly-overlay") ||
            node.querySelector(".calendly-overlay")
          ) {
            overwriteClosedButton();
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: false,
    });

    loadCalendlyScript();
    return () => {
      observer.disconnect();
    };
  }, []);


  const handleGetStarted = () => {
    navigate('/wallet-card/subscription/get-started')
  }

  const handleOpenCalendar = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault()
    }

    const initCalendlyPopup = () => {
      if (window.Calendly) {
        window.Calendly.initPopupWidget({
          url: linkCalendly,
        })
      } else {
        setTimeout(() => {
          if (window.Calendly) {
            window.Calendly.initPopupWidget({
              url: linkCalendly,
            })
          } else {
            window.open(linkCalendly, '_blank')
          }
        }, 500)
      }
    }

    const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')
    if (!existingScript) {
      const script = document.createElement('script')
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      script.async = true
      script.onload = () => {
        initCalendlyPopup()
      }
      document.body.appendChild(script)
    } else {
      initCalendlyPopup()
    }
  }

  return (
    <div className='card'>
      <div className='demo-page-container'>
        <div className='card-header demo-page-card__header border-0 flex-column'>
          <div className='header-section'
            style={{
              marginLeft: '20px',
            }}>
          <div className='card-label fw-bold  card-title align-items-start flex-column'>
            <span
              style={{
                lineHeight: '120%',
                letterSpacing: '0%',
                fontSize: '2.5rem',
                fontWeight: '700',
              }}
            >
              Schedule LeadzApp Demo
            </span>
            <span className='text-muted fw-bold fs-4'>Overview</span>
          </div>
          </div>

          <div className='row g-4'>
            <div className='col-lg-6'>
              <div className='card border-0 rounded-4 h-100'>
                <div className='card-body card-body-custom'>
                  <div>
                <p className='mb-4 fs-5 fw-bold'>
                  Get the most out of your LeadzApp, setup with a quick 20 minute call.
                </p>
                <div className='mb-8'>
                  <div className='text-gray-700 fs-5 lh-lg'>
                    <p className='mb-3'>
                      We'll walk you through everything you need to start capturing, engaging, and converting leads effortlessly.
                    </p>
                    <p className='mb-2 fw-semibold'>
                      Our team will:
                    </p>
                    <ul className='mb-3' style={{ listStyleType: 'disc', lineHeight: '1.25' }}>
                      <li className='mb-1'>Finalise your entire setup</li>
                      <li className='mb-1'>Customise your system for maximum performance</li>
                      <li className='mb-1'>Show you how to use the key features that drive real results</li>
                    </ul>
                    <p className='mb-4 fw-semibold'>
                      We handle the setup for you, stress-free.
                    </p>
                  </div>
                </div>
                <div className='mt-4'>
                  <Card className='calendly-card'>
                    <Card.Body className='calendly-card-body p-4 d-flex flex-column'>
                      <div className='booking-body text-white'>
                        <h3 className='text-white mb-2 fs-5' style={{
                          fontWeight: '700',
                          fontSize: '1.25rem',
                          lineHeight: '120%',
                          letterSpacing: '0%',
                        }}>Schedule Your 20-Minute Setup Call</h3>
                        <p className='text-white mb-2 fs-6'>
                          Choose a convenient time and we'll guide you through the complete setup process.
                        </p>

                        <div className='booking-details d-flex flex-column'>
                          <div className='d-flex align-items-center'>
                            <i className='bi bi-clock fs-5 me-2' style={{ color: '#ffffff' }}></i>
                            <span className='fs-6'>20 minutes</span>
                          </div>
                          <div className='d-flex align-items-center'>
                            <i className='bi bi-camera-video fs-5 me-2' style={{ color: '#ffffff' }}></i>
                            <span className='fs-6'>Video call</span>
                          </div>
                        </div>
                      </div>
                      <Button
                        variant='light'
                        className='btn-open-calendar'
                        onClick={handleOpenCalendar}
                      >
                        Book Now
                      </Button>
                    </Card.Body>
                  </Card>
                </div>
                </div>
                </div>
              </div>
            </div>
            <div className='col-lg-6 d-flex flex-column' style={{
              paddingRight: '2.5rem',
            }}>
              <div className='mb-6 flex-grow-1'>
                <div className='card border-0 rounded-4 overflow-hidden video-card-shadow bg-white'>
                  <div className='ratio ratio-16x9'>
                    <iframe
                      title='LeadzApp Demo Video'
                      src='https://www.loom.com/embed/313732a4bade483c8c8da93cc0ade7c6'
                      className='rounded-4'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                      referrerPolicy='strict-origin-when-cross-origin'
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
              <div className='features-section'>
                <h4 className='fw-bold mb-1'>Things we'll activate:</h4>
                <Row>
                  <Col md={6}>
                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>Digital business card</span>
                    </div>

                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>Dedicated number</span>
                    </div>

                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>
                        Automations and flow sequences
                      </span>
                    </div>

                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>Special offers</span>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>AI notes</span>
                    </div>

                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>AI suggestions</span>
                    </div>

                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>
                        Sales AI <span className='badge badge-light-warning ms-2'>coming soon</span>
                      </span>
                    </div>

                    <div className='d-flex align-items-center mb-1'>
                      <div className='timeline-icon symbol symbol-circle symbol-28px me-3 d-flex align-items-center justify-content-center'>
                        <i className='bi bi-check-circle check-icon-1'></i>
                      </div>
                      <span className='text-gray-800 fw-semibold fs-6'>
                        Voice AI <span className='badge badge-light-warning ms-2'>coming soon</span>
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        <div className='card-body demo-page-card__body'>
          <div className='bottom-section d-flex flex-column flex-md-row align-items-center justify-content-between mt-10'>
              <p className='mb-0 fs-5 fw-semibold text-gray-800 text-center text-md-start'>
                Don't want to wait? Get started now
              </p>
              <Button variant='outline-primary' className='btn-get-started' onClick={handleGetStarted}>
                Get started
              </Button>
            </div>
      </div>
    </div>
    </div>
  )
}

export default DemoPageLeadzApp

